import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { eur } from "@/lib/format";

// Confirmación de aprobar o rechazar un presupuesto (al rechazar, motivo opcional).
export const ResponderPresupuesto = ({ accion, presupuesto, onConfirmar, onClose }) => {
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);
  const aprobar = accion === "aprobar";
  const confirmar = async () => { setBusy(true); try { await onConfirmar(motivo); } finally { setBusy(false); } };
  return (
    <Dialog open={!!accion} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="responder-presupuesto">
        <DialogHeader>
          <DialogTitle className="text-[#1B2B4B]">{aprobar ? "¿Aprobar el presupuesto?" : "¿Rechazar el presupuesto?"}</DialogTitle>
          <DialogDescription>{presupuesto?.numero} · {eur(presupuesto?.total)}. {aprobar ? "La empresa recibirá tu aprobación al momento." : "La empresa recibirá tu respuesta y podrá enviarte una nueva versión."}</DialogDescription>
        </DialogHeader>
        {!aprobar && <Textarea value={motivo} onChange={(e) => setMotivo(e.target.value)} rows={3} maxLength={1000} placeholder="Motivo (opcional): precio, plazos, materiales…" data-testid="responder-motivo" />}
        <div className="flex flex-col gap-2">
          <Button onClick={confirmar} disabled={busy} data-testid="responder-confirmar"
            className={`h-11 rounded-xl text-white font-bold ${aprobar ? "bg-emerald-600 hover:bg-emerald-700" : "bg-rose-600 hover:bg-rose-700"}`}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : aprobar ? "Sí, aprobar" : "Rechazar presupuesto"}
          </Button>
          <Button variant="ghost" onClick={onClose} data-testid="responder-cancelar">Cancelar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
